export default __webpack_public_path__ + "static/wires-ea42b27bafc6980791898641c766878d.png";